export default __webpack_public_path__ + "static/media/rocket_anim_89.776c04c7.png";